import React from 'react';
import WName, {WArticle} from '../WName';
import Eon, {EonArticle} from '../Eon';
import PL from '../problems/ProblemLink';
import QL from '../faq/QuestionLink';
import LRL from '../longreads/LongReadLink';
import OML from '../ormaybe/OrMaybeLink';
import AL from './AngleLink';
import NW from '../neologisms/NewWord';
import {E1, E2, Qual} from '../common';

// This is war.
export const war = {
  name: "war",
  prelude: <span>Gippity tells <QL name="author">us</QL> to get rid of the ‘apocalypse’ <PL name="form">vibe</PL>.</span>,
  header: <span>
    This is literal <i>war</i>.
  </span>,
  outside: <span>(But ‘<QL>Gippity</QL>’  is, of course, <i>just a <LRL name="reactivity">reactive</LRL>, <QL name="salvation.thinking">unthinking</QL> <PL name="ai">robot</PL></i>.)</span>,
  preview: <div className="angle-preview">
    <p>It has to do with, yes, how ‘<AL name="die alone">we rise together, or we all die alone</AL>’. It has to do with us <LRL name="them">collectively</LRL> (and <AL name="handicap">reacto-biologically</AL>) dreading <AL>accountabiity</AL>… and so offloading it to <NW>ziggurats</NW>. It has to do with our collective <i>failure</i> at <NW word="overcome">Ganzesystemüberwindung</NW>.</p>
    <p>This is war. Not against some outside ‘<QL>other</QL>’, but against <PL>ourself</PL>. Against the reactive decay of our world to <NW>entropy</NW>, unless we actively (and <i><QL name="consciousness">consciously</QL></i>) maintain it.</p>
    <p>[Under construction; there's a lot to say here, so hopefully it will get better... soon, The main thing is that the 'enemy' isn't some other. It's the 'dark' tendency in ourself... and the cure is to flood the omniopticon with light.]</p>
  </div>,
//  text: <div className="angle-text">
//  </div>,
};

